import React from "react";
const Map = () => {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#4864e6"
    strokeWidth="2.5"
    strokeLinecap="butt"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="10" r="3" />
    <path d="M12 21.7C17.3 17 20 13 20 10a8 8 0 1 0-16 0c0 3 2.7 6.9 8 11.7z" />
  </svg>;
};

const Metrics = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#ffffff"
      strokeWidth="2.5"
      strokeLinecap="butt"
      strokeLinejoin="round"
    >
      <path d="M3 3v18h18" />
      <path d="M18.7 14.3L15 10.5l-2.7 2.7L7 8" />
    </svg>
  );
};

const BarChart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="none"
      stroke="hsla(212, 68%, 59%, 0.79)"
      strokeWidth="2.5"
      strokeLinecap="butt"
      strokeLinejoin="round"
    >
      <path d="M12 20v-6M6 20V10M18 20V4" />
    </svg>
  );
};

const Area = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 24 24"
      fill="none"
      stroke="hsla(212, 68%, 59%, 0.79)"
      strokeWidth="2.5"
      strokeLinecap="butt"
      strokeLinejoin="round"
    >
      <path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
};

export { Map, Metrics, BarChart, Area };
